import React from 'react';
type DoodleKind = 'leaf' | 'heart' | 'rays' | 'sparkle' | 'tomato' | 'broccoli' | 'lemon' | 'lunchbox';
type DoodleProps = {
  kind: DoodleKind;
  className?: string;
};
const shapes: Record<DoodleKind, React.ReactNode> = {
  leaf: <>
      <path d="M8 40C8 21 23 8 40 8c0 18-13 32-32 32z" fill="#16A65A" data-id="element-120" data-mp="2kakngflr99uf" />
      <path d="M10 38C18 28 26 20 36 12" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.7" data-id="element-121" data-mp="2p7uaxppl3bfm" />
    </>,
  heart: <path d="M24 41C11 32 6 24 6 17c0-6 4.5-10.5 10-10.5 3.7 0 6.6 2 8 5 1.4-3 4.3-5 8-5 5.5 0 10 4.5 10 10.5 0 7-5 15-18 24z" fill="#F51F64" data-id="element-122" data-mp="1skzdlclbg8x7" />,
  rays: <g stroke="#FFC83D" strokeWidth="4.5" strokeLinecap="round" data-id="element-123" data-mp="21hq9nozvbnrs">
      <path d="M24 6v11" data-id="element-124" data-mp="26inygkfdvg29" />
      <path d="M8 15l7.5 6.5" data-id="element-125" data-mp="26jz3enkketuy" />
      <path d="M40 15l-7.5 6.5" data-id="element-126" data-mp="26g1ipxic9u8y" />
    </g>,
  sparkle: <path d="M24 4c2 14 6 18 20 20-14 2-18 6-20 20-2-14-6-18-20-20 14-2 18-6 20-20z" fill="#FFC83D" data-id="element-127" data-mp="3cxolg0mfknwp" />,
  tomato: <>
      <circle cx="24" cy="28" r="15" fill="#F51F64" data-id="element-128" data-mp="3hvq5oovlet9r" />
      <ellipse cx="18.5" cy="23" rx="3.5" ry="2.2" fill="#FFFFFF" opacity="0.4" transform="rotate(-30 18.5 23)" data-id="element-129" data-mp="20393zsow24r2" />
      <path d="M24 13l2.6 3.4 4.2-.8-2.2 3.6 3.6 2.2-4.2.4L24 25l-4-3.2-4.2-.4 3.6-2.2-2.2-3.6 4.2.8z" fill="#16A65A" data-id="element-130" data-mp="1w2fi14v0b00t" />
    </>,
  broccoli: <>
      <path d="M20 26h8l-1.5 16h-5z" fill="#8FD4A8" data-id="element-131" data-mp="1m36pmgfshtgk" />
      <circle cx="16" cy="20" r="7.5" fill="#16A65A" data-id="element-132" data-mp="1m2eu15m6zvqa" />
      <circle cx="25" cy="15" r="8.5" fill="#16A65A" data-id="element-133" data-mp="1h3v5qyk4m7ur" />
      <circle cx="33" cy="21" r="7" fill="#16A65A" data-id="element-134" data-mp="1h5ocseyniu3a" />
      <circle cx="24" cy="23" r="7" fill="#12894A" data-id="element-135" data-mp="1ccv9lvitzttb" />
    </>,
  lemon: <>
      <ellipse cx="24" cy="26" rx="16" ry="12" fill="#FFC83D" transform="rotate(-20 24 26)" data-id="element-136" data-mp="18bt9zdl05fqt" />
      <ellipse cx="19" cy="22" rx="4" ry="2" fill="#FFFFFF" opacity="0.5" transform="rotate(-20 19 22)" data-id="element-137" data-mp="13cp00kq97dzf" />
      <path d="M36 15c2-3 5-4 8-3-1 3-4 5-8 3z" fill="#16A65A" data-id="element-138" data-mp="ydm2dlclsa1h" />
    </>,
  lunchbox: <>
      <path d="M18 15c0-6 12-6 12 0" stroke="#06234C" strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-139" data-mp="tej20e7kirzu" />
      <rect x="6" y="18" width="36" height="22" rx="7" fill="#079B98" data-id="element-140" data-mp="jr6l2kx5mzq8" />
      <rect x="6" y="15" width="36" height="9" rx="4.5" fill="#F51F64" data-id="element-141" data-mp="jszsi2fldnza" />
      <circle cx="24" cy="24" r="2.5" fill="#FFFFFF" data-id="element-142" data-mp="orkxsg9paxul" />
    </>
};

/** Pequeños acentos ilustrados inspirados en la portada (decorativos). */
export function Doodle({
  kind,
  className
}: DoodleProps) {
  return <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false" className={className} data-id="element-143" data-mp="es3prs6z87vg">
      {shapes[kind]}
    </svg>;
}